import React from 'react'

import SlidingPanel from "react-sliding-side-panel"
import InfoParam from "./info-param"
import Classes from 'classnames'
import Scrollbars from "react-custom-scrollbars-2"
import {POINT, QUEST} from "../../constants/model-type"
import {Button, IconButton} from "@mui/material"
import CloseIcon from "../../components/icons/close-icon"
import TrashIcon from "../../components/icons/trash-icon"
import EditIcon from "../../components/icons/edit-icon"

const debug = false
// const debug = "InfoPanel"

type Props = {
    items: any
}

type State = {
    data            : any
    confirmDelete   : boolean
}

export default class InfoPanel extends React.PureComponent<Props, State> {

    private panelSize!: number

    state: State = {
        data            : null,
        confirmDelete   : false
    }

    constructor(props: Props) {
        super(props)
        this.updateSize(true)
    }

    componentDidMount() {
        window.bus.subscribe("info-panel:show", this, this.onShow)
        window.bus.subscribe("info-panel:hide", this, this.onHide)
        window.bus.subscribe("window-resize", this, this.updateSize)
        window.bus.subscribe("reload-completed", this, this.onReloadCompleted)
    }

    componentWillUnmount() {
        window.bus.unsubscribe(this)
    }

    updateSize = (noUpdate = false) => {
        const panelSize = window.innerHeight > 700 ? 40 : 60

        if (this.panelSize !== panelSize) {
            this.panelSize = panelSize
            if (!noUpdate) this.forceUpdate()
        }
    }

    onShow = (data: any) => {
        debug && console.log(debug, "onShow", data)
        this.setState({ data, confirmDelete: false })
    }

    onHide = () => {
        debug && console.log(debug, "onHide")
        this.setState({ data: null, confirmDelete: false })
    }

    onReloadCompleted = () => {
        if (this.state.data) {
            let newData
            switch (this.state.data.type) {
                case POINT: newData = this.props.items.points.get(this.state.data.id); break
                case QUEST: newData = this.props.items.quests.get(this.state.data.id); break
            }
            this.onShow(newData)
        }
    }

    onDelete = () => {
        window.bus.triggerEvent("delete-point", this.state.data.id)
        this.onHide()
    }

    onDeleteObserversAttempt = () => {
        this.setState({
            confirmDelete: true
        })
        return
    }

    onDeleteObserversCancel = () => {
        this.setState({
            confirmDelete: false
        })
        return
    }

    // calculated point is derived — removing its observers removes it
    onDeleteObservers = () => {
        window.bus.triggerEvent("delete-point", this.state.data.observerIds)
        this.onHide()
        return
    }

    onEdit = () => {
        window.bus.triggerEvent("edit-point:show", this.state.data)
        this.onHide()
    }

    render() {
        const classes = Classes("info-panel", {
            'default'       : window.innerWidth > 700,
            'small-screen'  : window.innerWidth <= 700,
            'mobile-device' : window.isMobileDevice
        })

        const showIcon = !_.get(this.state, 'data.isCustom', false) && !_.get(this.state, 'data.triangulationType', false) && _.get(this.state, 'data.markerIcon', false)

        return (
            <SlidingPanel panelClassName="info-panel-container"
                          type="bottom"
                          noBackdrop={true}
                          isOpen={!!this.state.data}
                          size={this.panelSize}>
                {!!this.state.data
                    ? <div className={classes}>
                        <div className="info-buttons-panel">
                            <IconButton size="large" color="default" onClick={this.onHide}>
                                <CloseIcon/>
                            </IconButton>
                        </div>

                        <div className="info-title">
                            {showIcon &&
                                <img className="icon"
                                     src={this.state.data.markerIcon.icon.url || this.state.data.markerIcon.icon}
                                     alt={this.state.data.icon}/>}
                            <div className="name">{this.state.data.name}</div>
                        </div>
                        <Scrollbars className="info-scroll">
                            {_.map(this.state.data.infoPrams, (param: any, key: number) => <InfoParam key={key}
                                                                                                      data={param}/>)}

                            {this.state.data.isCustom &&
                                <div className="edit-button" onClick={this.onEdit}>
                                    <EditIcon className="edit-icon"/>
                                    Редактировать
                                </div>}

                            {this.state.data.isCustom &&
                                <div className="delete-button" onClick={this.onDelete}>
                                    <TrashIcon className="delete-icon"/>
                                    Удалить точку
                                </div>}

                            {this.state.data.triangulationType &&
                                <div className="delete-confirm-wrapper">
                                    <div className={Classes("delete-button", {'hidden': this.state.confirmDelete})} onClick={this.onDeleteObserversAttempt}>
                                        <TrashIcon className="delete-icon"/>
                                        Удалить точку
                                    </div>

                                    {this.state.confirmDelete &&
                                        <div className="delete-confirm">
                                            <div className="delete-confirm-buttons">
                                                <Button variant="outlined" color="error" size="small" onClick={this.onDeleteObservers}>Да, удалить</Button>
                                                <Button variant="outlined" size="small" onClick={this.onDeleteObserversCancel}>Отмена</Button>
                                            </div>
                                            <div className="delete-confirm-text">
                                                Будут удалены все точки наблюдения, по которым рассчитана точка: {_.size(this.state.data.observerIds)} шт.
                                            </div>
                                        </div>}
                                </div>}
                        </Scrollbars>
                    </div>
                    : null}
            </SlidingPanel>
        )
    }
}
